import {
  GetAllTinybirdEventsFrontendRequestBodyType,
  GetAllTinybirdEventsResponseBodyType,
} from "@intelligems/ig-types";
import { api } from "@src/api/api";
import { unregisteredTinybirdEvents } from "@src/api/queryKeys";
import { useQuery } from "@tanstack/react-query";

const getUnregisteredTinybirdEvents = async () => {
  const resp = await api.get<GetAllTinybirdEventsResponseBodyType>(
    "/v2/custom-events/unregistered"
  );
  return resp.data;
};

export const useGetUnregisteredTinybirdEvents = () => {
  return useQuery<any>({
    queryKey: unregisteredTinybirdEvents.all,
    queryFn: async () => getUnregisteredTinybirdEvents(),
  });
};
